import { styled as muiStyled, css } from '@mui/material/styles';
import React from 'react';

import Arranger from '~c/components/base/arranger';
import { getDesignTokens } from '~c/components/base/core';
import { LinearProgress } from '~c/components/base/progress';
import { spc } from '~c/components/base/spacer';
import Text from '~c/components/base/text';
import { useDesignTokens } from '~c/hooks/use-design-tokens';

interface Props {
  className?: string;
  /**
   * Progress 0-100
   */
  value?: number | null;
  /**
   * Hide progress bar
   */
  hideProgressBar?: boolean;
  /**
   * When true, use nav-on-dark text color (e.g. when rendered inside the left nav column).
   */
  inNav?: boolean;
}

const ProgressWithTextImpl: React.FC<Props> = ({
  className,
  value,
  hideProgressBar,
  inNav,
}) => {
  const progress = value ?? 0;
  const progressText = `${Math.round(progress)}%`;
  const tokens = useDesignTokens();

  return (
    <Arranger
      className={className}
      alignItems="center"
      justify="center"
      data-in-nav={inNav ? true : undefined}
    >
      {!hideProgressBar && (
        <LinearProgress
          className="progress-bar"
          variant="determinate"
          color="inherit"
          gradientColor={tokens.accent}
          value={progress}
          sx={{ mr: spc.xs }}
        />
      )}
      <Text
        className="progress-text"
        sz="body14"
        align={hideProgressBar ? 'center' : 'right'}
      >
        {progressText}
      </Text>
    </Arranger>
  );
};

export default muiStyled(ProgressWithTextImpl)(({ theme }) => {
  const tokens = getDesignTokens(theme.palette.mode, theme.accentPalette);
  return css`
    width: 100%;

    .progress-bar {
      flex-grow: 1;
    }

    .progress-text {
      /* fits the word (100%) */
      width: 34px;
      .MuiTypography-root {
        color: ${tokens.textSecondary};
      }
    }
    &[data-in-nav='true'] .progress-text .MuiTypography-root {
      color: ${tokens.nav.itemTextOnDark};
    }
  `;
});
